import { apiInstance, gql } from "@/services/httpAdapter";

export const getActiveFrequencies = async ({ locationId, section }) => {
	const query = gql`
		query getActiveFrequencies($locationId: String, $section: String) {
			getActiveFrequencies(locationId: $locationId, section: $section) {
				marketSharesMetrics {
					_id
					commissionCycleId
					dealerCodeFS
					franchises
					frequency
					oemReference
				}
				hasSalesPerformance
				financialStatementsMetrics {
					commissionCycleId
					dealerCodeFS
					franchises
					frequency
					oemReference
					_id
					preownedPage {
						pageName
						pageNumber
					}
					servicePage {
						pageName
						pageNumber
					}
					bodyShopPage {
						pageName
						pageNumber
					}
					partsPage {
						pageName
						pageNumber
					}
				}
			}
		}
	`;

	const variables = {
		locationId,
		section,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getActiveFrequencies;
	} catch (err) {
		console.log(err);
	}

	return null;
};
